export default __webpack_public_path__ + "static/media/export_icon.5d034db0.svg";